import React from 'react'
import { AuthResponse, AuthUser } from './AuthService'

interface AuthContextValue {
  authResponse: AuthResponse
  onReady: () => void
  onLogout: () => void
  onUserNotFound: (user: AuthUser) => void
}

const AuthContext = React.createContext<AuthContextValue | null>(null)

export function AuthContextProvider({
  children,
  ...value
}: AuthContextValue & { children: React.ReactNode }) {
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}

export function useAuthContext(): AuthContextValue {
  const ctx = React.useContext(AuthContext)
  if (!ctx)
    throw new Error('useAuthContext must be used within AuthContextProvider')
  return ctx
}
